var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountOverviewPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3125 0.125C24.4297 0.125 25.375 1.07031 25.375 2.1875V17.3125C25.375 18.4727 24.4297 19.375 23.3125 19.375H2.6875C1.52734 19.375 0.625 18.4727 0.625 17.3125V2.1875C0.625 1.07031 1.52734 0.125 2.6875 0.125H23.3125ZM2.6875 1.5C2.30078 1.5 2 1.84375 2 2.1875V4.25H24V2.1875C24 1.84375 23.6562 1.5 23.3125 1.5H2.6875ZM23.3125 18C23.6562 18 24 17.6992 24 17.3125V8.375H2V17.3125C2 17.6992 2.30078 18 2.6875 18H23.3125ZM8.875 14.3906V14.7344C8.875 15.0352 8.61719 15.25 8.35938 15.25H5.26562C4.96484 15.25 4.75 15.0352 4.75 14.7344V14.3906C4.75 14.1328 4.96484 13.875 5.26562 13.875H8.35938C8.61719 13.875 8.875 14.1328 8.875 14.3906ZM17.125 14.3906V14.7344C17.125 15.0352 16.8672 15.25 16.6094 15.25H10.7656C10.4648 15.25 10.25 15.0352 10.25 14.7344V14.3906C10.25 14.1328 10.4648 13.875 10.7656 13.875H16.6094C16.8672 13.875 17.125 14.1328 17.125 14.3906Z",
    fill: "#CE0E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOverviewPayment);
export default __webpack_public_path__ + "static/media/AccountOverviewPayment.13afb997862d087f9d4e506a07519eb7.svg";
export { ForwardRef as ReactComponent };